import React, { useRef, useState, useEffect } from "react";
import ReactFlow from "react-flow-renderer";
import { getTextWidth } from "utils/shortTermGoals";
import RoadmapDisplayTitle from "./roadmapDisplayTitle";

const StaircaseFlow = ({ nodes, edges, openEditForm, isExpanded }) => {

  const [hoveredNode, setHoveredNode] = useState(null);
  const [isHover, setIsHover] = useState(false);
  const [titleData, setTitleData] = useState({})

  console.log('Node IDs:', nodes.map(n => n.id));
  console.log('Node Edge sources/targets:', edges.map(e => ({ source: e.source, target: e.target })));

  useEffect(() => {
    setTimeout(() => {
      const tmp = document.querySelector(".custom-staircase-class .react-flow__nodes");
      const tmp1 = document.querySelector(".custom-staircase-class .react-flow__edges g");
      // console.log('sss tmp', tmp, tmp1.style)
      if (tmp && tmp1) {
        tmp.style.transform = 'translate(0px, -120px) scale(1)';
        tmp1.setAttribute('transform', 'translate(0, -120) scale(1)');
      }
    }, 10)
  }, [isExpanded])

// useEffect(() => {
//   console.log('sss isExpanded outside', isExpanded)
//   if(isExpanded){
//     const nodeElements = document.querySelectorAll(".react-flow__node.react-flow__node-default");
//     console.log('sss isExpanded0', isExpanded)
//     nodeElements.forEach((nodeElement) => {
//       const nodeElementWidth = nodeElement.offsetWidth;
//       const stepTitleElement = nodeElement.querySelector('.step-title');
//       console.log('sss isExpanded', isExpanded)
//       if (!stepTitleElement) return;
//       const computedStyle = window.getComputedStyle(stepTitleElement);
//       const font = `${computedStyle.fontSize} ${computedStyle.fontFamily}`;
//       const text = stepTitleElement.textContent;
//       const textWidth = getTextWidth(text, font)
//       console.log('sss isExpanded1', isExpanded)
      
//       if (stepTitleElement && (textWidth > (nodeElementWidth-20)) ) {
//         console.log('sss isExpanded2', isExpanded)
//         stepTitleElement.classList.add('clamp-2')
//       }
//     });
//   }
// }, [isExpanded]);


// useEffect(() => {
//   const nodeElements = document.querySelectorAll(".react-flow__node.react-flow__node-default");

//   nodeElements.forEach((nodeElement) => {
//     const stepTitleElement = nodeElement.querySelector('.step-title');
//     if (!stepTitleElement) return;

//     // Initial line clamp
//     stepTitleElement.style.display = '-webkit-box';
//     stepTitleElement.style.webkitLineClamp = 2;
//     stepTitleElement.style.webkitBoxOrient = 'vertical';
//     stepTitleElement.style.overflow = 'hidden';

//     // Allow browser to apply styles
//     requestAnimationFrame(() => {
//       const isClamped = stepTitleElement.scrollHeight > stepTitleElement.clientHeight;

//       if (isClamped) {
//         // Increase the clamp by 1 if content is still overflowing
//         stepTitleElement.style.webkitLineClamp = 3;
//       }
//     });
//   });
// }, []);


  // Enhance nodes with hover styling
  const handleNodeMouseEnter = (event, node) => {
    console.log('handleNodeMouse Enter', node, node.id)
    setTimeout(() => {
      setIsHover(true)
    }, 2000)
    // setHoveredNode(node);
    const nodeElement = document.querySelector(`[data-id="${node.id}"]`);
    const nodeElementWidth = nodeElement.offsetWidth;
    if (nodeElement) {
      const stepTitleElement = nodeElement.querySelector('.step-title');
      const computedStyle = window.getComputedStyle(stepTitleElement);
      const font = `${computedStyle.fontSize} ${computedStyle.fontFamily}`;
      const text = stepTitleElement.textContent;
      const textWidth = getTextWidth(text, font)
      console.log('sss text handleNodeMouseEnter', text, text.length)
      
      if (stepTitleElement && (textWidth > (nodeElementWidth-20)) && text.length >= 35 ) {
        setIsHover(true)
        // stepTitleElement.classList.add('clamp-2')
        setTitleData(pre => ({
          ...pre,
          title: node.data.title,
          position: nodeElement.getBoundingClientRect()
        }));
      }
    }

  }
  const handleNodeMouseLeave = (event, node) => {
    console.log('handleNodeMouse Leave', node, node.id)
    setTimeout(() => {
      // setIsHover(false)
    }, 100)
    // setHoveredNode(node);
    setTitleData({})
  }
  
  // useEffect(() => {
  //   if(hoveredNode){
  //     const nodeElement = document.querySelector(`[data-id="${hoveredNode.id}"]`);
  //     const nodeElementWidth = nodeElement.offsetWidth;
  //     console.log('sss hi hoveredNode', isHover)

  //     if (nodeElement) {
  //       const stepTitleElement = nodeElement.querySelector('.step-title');
  //       const computedStyle = window.getComputedStyle(stepTitleElement);
  //       const font = `${computedStyle.fontSize} ${computedStyle.fontFamily}`;
  //       const text = stepTitleElement.textContent;
  //       const textWidth = getTextWidth(text, font)
        
  //       if (stepTitleElement) {
  //         console.log('sss hi hoveredNode Found step-title element:', stepTitleElement, textWidth, nodeElementWidth, isHover);
  //         if(textWidth > (nodeElementWidth-20) && isHover){
  //           console.log('sss hi hoveredNode Found step-title element if:', stepTitleElement, textWidth, nodeElementWidth, isHover);
  //           nodeElement.style.setProperty('width', `${textWidth+20}px`, 'important');
  //           nodeElement.style.setProperty('z-index', '999');
  //         }
  //         else{
  //           console.log('sss hi hoveredNode Found step-title element else:', stepTitleElement, textWidth, nodeElementWidth, isHover);
  //           nodeElement.style.removeProperty('width');
  //           nodeElement.style.setProperty('z-index', '3');
  //         }
  //       }
  //     }
  //   }
  // }, [isHover]);

 
  return (
    <div
      style={{
        width: "100%",
        height: "300px",
        border: "none",
        overflow: "hidden",
        background: "linear-gradient(to bottom, #CCE6E7 1px, transparent 1px)", // Horizontal lines for effect
        backgroundSize: "100% 30px",
        position: "relative",
        whiteSpace: "nowrap",
        scrollbarWidth: "thin", // Thin scrollbar
      }}
    >
      <div
        style={{
          width: "200%", // Ensure enough width for horizontal scrolling
          height: "100%", // Enough space for vertical movement (can be adjusted)
          backgroundColor: "transparent",
          position: "relative",
          transition: "transform 0.3s ease-out", // Smooth transition when moving vertically
        }}
        className="custom-staircase-class"
      >
        <ReactFlow
          elements={[...nodes, ...edges]}
          // nodes={nodes}
          // edges={edges}
          nodesDraggable={false} // Disable node dragging
          nodesConnectable={true}
          elementsSelectable={false}
          onNodeMouseEnter={handleNodeMouseEnter}
          onNodeMouseLeave={handleNodeMouseLeave}
          zoomOnScroll={false}
          zoomOnDoubleClick={false}
          onElementClick={(event, element) => {
            // console.log('click', event, element)
            openEditForm(event, element.id)
          }}
          panOnScroll={true}
          panOnDrag={false}
          panOnScrollMode="free"
          panOnDragMode={false}
          minZoom={1}
          maxZoom={1}
          style={{
            width: "100%",
            height: "100%",
            background: "transparent",
            border: "none",
            boxShadow: "none",
            // pointerEvents: "none", // Disable interactions with the canvas
          }}
        />
        {
          (titleData.title && titleData.position) && <RoadmapDisplayTitle
            key={titleData.id}
            phaseTitle={titleData.title}
            position={titleData.position}
          />
        }
      </div>
    </div>

  );
};

export default StaircaseFlow;
